import { WidgetMetricCardLoading } from '@/_containers';

import { Layout } from './layout';

export function Loading() {
  return (
    <Layout>
      <WidgetMetricCardLoading />
    </Layout>
  );
}
